import { __extends } from "tslib";
import { ASObject } from '@awayfl/avm2';
/**
 * Base export class for dispatching events
*
* @export class away.events.EventDispatcher
*
*/
var EventDispatcherBase = /** @class */ (function (_super) {
    __extends(EventDispatcherBase, _super);
    function EventDispatcherBase(target) {
        if (target === void 0) { target = null; }
        var _this = _super.call(this) || this;
        _this._listenerObjects = new Array();
        _this._t = target || _this;
        return _this;
    }
    EventDispatcherBase.prototype.toString = function () {
        return '';
    };
    /**
     * Add an event listener
     * @method addEventListener
     * @param {String} Name of event to add a listener for
     * @param {Function} Callback function
     */
    EventDispatcherBase.prototype.addEventListener = function (type, listener, useCapture, priority, useWeakReference) {
        if (useCapture === void 0) { useCapture = false; }
        if (priority === void 0) { priority = 0; }
        if (useWeakReference === void 0) { useWeakReference = false; }
        if (!this._listenerObjects)
            return;
        var l = this._listenerObjects[type];
        if (l === undefined)
            l = this._listenerObjects[type] = new ListenerObject();
        l.addEventListener(listener, priority);
    };
    /**
     * Remove an event listener
     * @method removeEventListener
     * @param {String} Name of event to remove a listener for
     * @param {Function} Callback function
     */
    EventDispatcherBase.prototype.removeEventListener = function (type, listener) {
        if (!this._listenerObjects)
            return;
        var l = this._listenerObjects[type];
        if (l) {
            l.removeEventListener(listener);
            if (l.numListeners == 0)
                delete this._listenerObjects[type];
        }
    };
    /**
     * Dispatch an event
     * @method dispatchEvent
     * @param {Event} Event to dispatch
     */
    EventDispatcherBase.prototype.dispatchEvent = function (event) {
        if (!this._listenerObjects) {
            //throw("dispatching event on object that wasnt init yet");
            return;
        }
        var l = this._listenerObjects[event.type];
        if (l) {
            if (!event.target)
                event.target = this._t;
            //console.log("dispatchEvent", event.type, (<any>this).adaptee?.id);
            l.dispatchEvent(event);
        }
        return true;
    };
    /**
     * check if an object has an event listener assigned to it
     * @method hasListener
     * @param {String} Name of event to remove a listener for
     * @param {Function} Callback function
     */
    EventDispatcherBase.prototype.hasEventListener = function (type, listener) {
        if (this._listenerObjects[type] === undefined)
            return false;
        if (listener != null)
            return this._listenerObjects[type].getEventListenerIndex(listener) !== -1;
        return this._listenerObjects[type].numListeners > 0;
    };
    return EventDispatcherBase;
}(ASObject));
export { EventDispatcherBase };
function sortListenersByPriority(a, b) {
    return a.priority < b.priority ? -1 : 1;
}
var ListenerObject = /** @class */ (function () {
    function ListenerObject() {
        this._index = 0;
        this._singlePriority = 0;
        this._listeners = new Array();
        this.numListeners = 0;
    }
    ListenerObject.prototype.addEventListener = function (listener, priority) {
        // if event already exists, it will not be added again, and old priority will remain
        if (priority === void 0) { priority = 0; }
        if (!this._listenersByPriority) {
            // single priority mode:
            if (this._listeners.indexOf(listener) !== -1) {
                // the listener is already present - do nothing just return
                return;
            }
            else {
                // its a new listener
                if (this._listeners.length == 0 || priority == this._singlePriority) {
                    // same priority as existing listeners. just add it and return
                    this._listeners.push(listener);
                    this.numListeners++;
                    return;
                }
                else {
                    // different priority - switch to multi-priority mode
                    if (this._singlePriority < priority) {
                        this._listenersByPriority = [
                            {
                                priority: this._singlePriority,
                                listeners: this._listeners.concat()
                            },
                            {
                                priority: priority,
                                listeners: [listener]
                            }
                        ];
                    }
                    else {
                        this._listenersByPriority = [
                            {
                                priority: priority,
                                listeners: [listener]
                            },
                            {
                                priority: this._singlePriority,
                                listeners: this._listeners.concat()
                            }
                        ];
                    }
                    this.numListeners++;
                }
                return;
            }
        }
        // multi-priority mode:
        //check if a listener already exists
        for (var i = 0; i < this._listenersByPriority.length; i++) {
            if (this._listenersByPriority[i].listeners.indexOf(listener) !== -1) {
                return;
            }
        }
        // find priority item
        var priorityItem = null;
        for (var i = 0; i < this._listenersByPriority.length; i++) {
            if (this._listenersByPriority[i].priority == priority) {
                priorityItem = this._listenersByPriority[i];
                break;
            }
        }
        if (!priorityItem) {
            priorityItem = {
                priority: priority,
                listeners: []
            };
            this._listenersByPriority.push(priorityItem);
            if (this._listenersByPriority.length > 1) {
                this._listenersByPriority.sort(sortListenersByPriority);
            }
        }
        priorityItem.listeners.push(listener);
        this.numListeners++;
    };
    ListenerObject.prototype.removeEventListener = function (listener) {
        var index = -1;
        if (!this._listenersByPriority) {
            index = this._listeners.indexOf(listener);
            if (index === -1)
                return;
            this._listeners.splice(index, 1);
            this.numListeners--;
            return;
        }
        //check if listener exists
        for (var i = 0; i < this._listenersByPriority.length; i++) {
            index = this._listenersByPriority[i].listeners.indexOf(listener);
            if (index !== -1) {
                this.numListeners--;
                this._listenersByPriority[i].listeners.splice(index, 1);
                return;
            }
        }
    };
    ListenerObject.prototype.dispatchEvent = function (event) {
        // when listeners do attach/remove new listeners the new listeners will be ignored during this dispatch,
        // and listeners that got removed will still dispatch during this dispatch
        // this means we need to concat the listener-array before we iterate it
        if (!this._listenersByPriority) {
            // single-priority mode:
            var listeners = this._listeners.length > 1 ? this._listeners.concat() : this._listeners;
            var numListeners = listeners.length;
            var i = 0;
            for (i = 0; i < numListeners; i++) {
                if (listeners[i])
                    listeners[i].call(listeners[i], event);
            }
            return;
        }
        // multi-priority mode:
        var p = this._listenersByPriority.length;
        //console.log("multi-priority mode", p);
        while (p > 0) {
            p--;
            //console.log("multi-priority mode next", p);
            var listeners = this._listenersByPriority[p].listeners.length > 1 ? this._listenersByPriority[p].listeners.concat() : this._listenersByPriority[p].listeners;
            var numListeners = listeners.length;
            var i = 0;
            //let len=events.length;
            //console.log("events", len);
            for (i = 0; i < numListeners; i++) {
                if (listeners[i])
                    listeners[i].call(listeners[i], event);
            }
        }
        if (this._listenersByPriority.length == 1) {
            // if only 1 priority exists, we can go back to single-priority-mode
            this._listeners = this._listenersByPriority[0].listeners.concat();
            this._singlePriority = this._listenersByPriority[0].priority;
            this._listenersByPriority = null;
        }
    };
    /**
     * get Event Listener Index in array. Returns -1 if no listener is added
     * @method getEventListenerIndex
     * @param {String} Name of event to remove a listener for
     * @param {Function} Callback function
     */
    ListenerObject.prototype.getEventListenerIndex = function (listener) {
        if (!this._listenersByPriority) {
            // single-priority mode:
            return this._listeners.indexOf(listener);
        }
        // multi-priority mode:
        for (var i = 0; i < this._listenersByPriority.length; i++) {
            for (var e = 0; e < this._listenersByPriority[i].listeners.length; e++) {
                if (this._listenersByPriority[i].listeners[e] == listener) {
                    return i;
                }
            }
        }
        return -1;
    };
    return ListenerObject;
}());
export { ListenerObject };
export default EventDispatcherBase;
